import builder from '../builder';
import Calendar from '../../streamline-icons/bold/calendar.svg';

export default builder('IconCalendarBold', Calendar);
